import clsx from 'clsx/lite';

export function Container({
  className,
  children,
  isSmall,
  ...props
}: React.HTMLProps<HTMLDivElement> & {
  isSmall?: boolean;
}) {
  return (
    <div
      className={clsx(
        'mx-auto flex w-full flex-col',
        isSmall ? 'max-w-[--small-width]' : 'max-w-[--content-width]',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
